import { NonCommunityPostPage } from '@/components/postPages/PostPage';

export default NonCommunityPostPage;
